<!-- MODAL AEAT — NIF-1095: KO → alert AEAT; details → tabla cotejo (sin fila resultado) -->
<tec-modal
	[isVisible]="showAeatModal"
	[title]="'PROCESSES.DETAIL.AEAT_MODAL.TITLE' | translate"
	(closeEvent)="showAeatModalChange.emit(false)">
	<ng-container body>
		@if (detail?.data?.OCR?.antifraud?.AEAT === BOOLEAN_STATUS.KO) {
			<tec-alert
				status="warning"
				[msg]="'PROCESSES.DETAIL.AEAT_ERROR' | translate"
				[hiddenCloseButton]="true"
			></tec-alert>
		}

		@if (detail?.data?.OCR?.actions?.AEAT?.details) {
			<tec-table
				[headers]="[
					{ label: 'PROCESSES.DETAIL.AEAT_MODAL.TYPE' | translate },
					{ label: 'PROCESSES.DETAIL.AEAT_MODAL.DATA' | translate },
					{ label: 'PROCESSES.DETAIL.AEAT_MODAL.AEAT' | translate },
				]"
				[rows]="aeatCompareRows()"
				[config]="{ clickeable: false, borderless: true }"
			></tec-table>
		} @else {
			<tec-empty-state [title]="'GENERAL.NO_DATA' | translate" />
		}
	</ng-container>
</tec-modal>

<!-- MODAL cotejo FORM match_data -->
<tec-modal
	[isVisible]="showFormMatchModal"
	[title]="formMatchDataModalTitleKey | translate"
	(closeEvent)="showFormMatchModalChange.emit(false)">
	<ng-container body>
		@if (formMatchCompareHasMismatch) {
			<tec-alert
				status="warning"
				[msg]="formMatchDataModalAlertKey | translate"
				[hiddenCloseButton]="true"
			/>
		}
		@if (formMatchCompareRows.length) {
			<tec-table
				[headers]="[
					{ label: 'PROCESSES.DETAIL.FORM_MATCH_DATA_MODAL.TYPE' | translate },
					{ label: 'PROCESSES.DETAIL.FORM_MATCH_DATA_MODAL.FORM' | translate },
					{ label: 'PROCESSES.DETAIL.FORM_MATCH_DATA_MODAL.REFERENCE' | translate },
				]"
				[rows]="formMatchCompareRows"
				[config]="{ clickeable: false, borderless: true }"
			/>
		} @else {
			<tec-empty-state [title]="'GENERAL.NO_DATA' | translate" />
		}
	</ng-container>
</tec-modal>

<!-- MODAL concordancia documentos (nombre/apellidos vs registro) -->
<tec-modal
    [isVisible]="!!compareModalDoc"
    [title]="'OPERATIONS.DETAIL.DOCUMENTS_COMPARE_MODAL_TITLE' | translate"
    (closeEvent)="closeDocumentsCompare.emit()"
>
    <ng-container body>
        @if (compareModalHasMismatch) {
            <tec-alert
                status="warning"
                [msg]="'OPERATIONS.DETAIL.DOCUMENTS_COMPARE_MODAL_ALERT' | translate"
                [hiddenCloseButton]="true"
            />
        }
        @if (compareModalDoc) {
            <tec-table
                [headers]="[
                    { label: ('OPERATIONS.DETAIL.DOCUMENTS_COMPARE_MODAL_COL_TYPE' | translate) },
                    { label: ('OPERATIONS.DETAIL.DOCUMENTS_COMPARE_MODAL_COL_DOCUMENT' | translate) },
                    { label: ('OPERATIONS.DETAIL.DOCUMENTS_COMPARE_MODAL_COL_DATA' | translate) },
                ]"
                [rows]="compareModalRows"
                [config]="{ clickeable: false, borderless: true }"
            />
        }
    </ng-container>
</tec-modal>

<!-- MODAL MRZ -->
<tec-modal
	[isVisible]="showMrzModal"
	[title]="'PROCESSES.DETAIL.READ_MRZ_MODAL.TITLE' | translate"
	(closeEvent)="showMrzModalChange.emit(false)">
	<ng-container body>
        @if (showMrzAlert) {
            <tec-alert
                status="warning"
                [msg]="'PROCESSES.DETAIL.READ_MRZ_MODAL.ALERT' | translate"
                [hiddenCloseButton]="true"
            ></tec-alert>
        }

        <tec-tile>
            <div style="display: flex; flex-direction: column;">
                <span>{{ detail?.data?.OCR?.mrz1 || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                <span>{{ detail?.data?.OCR?.mrz2 || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                @if (detail?.data?.OCR?.mrz3) {
                    <span>{{ detail.data?.OCR?.mrz3 }}</span>
                }
            </div>
        </tec-tile>
	</ng-container>
</tec-modal>
